<template>
  <div id="funnel" class="bg-light py-5">
    <div class="container mb-4">
      <a :href="voyage_link" class="btn btn-outline-primary"
        >Retour au voyage</a
      >
    </div>

    <div class="funnel-els container">
      <div class="row">
        <div class="col-lg-6">
          <funnel-form />
        </div>
        <div class="col-lg-6 mt-5 mt-lg-0">
          <date-picker />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FunnelForm from "./components/FunnelForm";
import DatePicker from "./components/DatePicker";

export default {
  name: "Funnel",

  components: {
    FunnelForm,
    DatePicker
  },

  data: () => ({
    voyage_link: window.funnel_data.voyage_link
  }),

  mounted() {
    this.$store.dispatch("init");
  }
};
</script>
